import { versionUrl } from 'endpoints';
async function loadScope( url, scope, identity, crossorigin ) {
  //check if it's localhost so it can be loaded appropriately
  const isLocalhost = window.location.hostname.indexOf( 'localhost' ) >= 0;
  const isUrlLocalhost = url.indexOf( 'localhost' ) >= 0;
  //set the remote to the url passed in
  let remoteUrl = url;
  //if there's an identity, which is needed to get the json, try to get the json version file
  if ( identity ) {
    let hasError = false;
    const version = await fetch( versionUrl ).then( response => response.json() ).then( data => {
      return data.version;
    } ).catch( error => {
      if ( error ) {
        //if there's an error it means we got html back because the json file doesn't exist
        hasError = true;
      }
    } );
    if ( !hasError && version ) {
      if ( !isLocalhost ) {
        //append version to base url because that's where the js will be
        remoteUrl = `${ url }/${ version }`;
      } else if ( isLocalhost && !isUrlLocalhost ) {
        //if it's localhost and the url is not localhost, then we need to append the version to the url
        remoteUrl = `${ url }/${ version }`;
      }
    }
  } else {
    throw new Error( 'No identity provided, cannot look up version info for module federation' );
  }
  const element = document.createElement( 'script' );
  const promise = new Promise( ( resolve, reject ) => {
    element.src = `${ remoteUrl }/remoteEntry.js`;
    element.type = 'text/javascript';
    element.async = true;
    if ( crossorigin === true ) {
      element.crossOrigin = 'anonymous';
    }
    element.onload = () => resolve( window[ scope ] );
    element.onerror = () => resolve();
  } );
  promise.catch( error => {
    //do nothing
    return;
  } );
  document.head.appendChild( element );
  promise.finally( () => document.head.removeChild( element ) );
  return promise;
}
export async function loadModule( url, scope, module, identity, crossorigin = false ) {
  try {
    const container = await loadScope( url, scope, identity, crossorigin );
    await __webpack_init_sharing__('default'); // eslint-disable-line
    await container.init(__webpack_share_scopes__.default); // eslint-disable-line
    const factory = await container.get( module );
    return factory();
  } catch ( error ) {
    console.log( error );
  }
}